import React from 'react'
import PropTypes from 'prop-types'
import { css } from '@linaria/core'
import { colors } from '@fs/zion-ui'
import { boolAttr } from '@fs/zion-frontend-friends'

const vignetteCss = css`
  position: absolute;
  height: 100%;
  width: 100%;
  background: ${colors.gray100};
  opacity: 0.55;
  pointer-events: none;

  &[fade] {
    background: linear-gradient(0deg, ${colors.gray100} 0%, transparent 35%);
  }
`

export default function TileScrim({ fade }) {
  return <div className={vignetteCss} fade={boolAttr(fade)} />
}

TileScrim.propTypes = {
  /** If true, the scrim will fade out instead of covering the whole tile. */
  fade: PropTypes.bool,
}
